import { validateEmail, validatePassword } from '@utils';
import { FormFields } from 'hooks';

export type SignInFormFieldNames = 'email' | 'password';

export const formFields: FormFields<SignInFormFieldNames> = {
  email: {
    name: 'email',
    initialValue: '',
    isRequired: true,
    validate: validateEmail,
    requiredMessage: 'Email is required'
  },
  password: {
    name: 'password',
    initialValue: '',
    isRequired: true,
    validate: validatePassword,
    requiredMessage: 'Password is required'
  }
};
